export default 'sync';
